<template>
  <div :class="$style.buttons">
    <div :class="$style.green"></div>
    <div :class="$style.purple"></div>
    <div :class="$style.red"></div>
  </div>
</template>
<script>
export default {
  name: 'WindowСontrolButtons',
}
</script>
<style lang="scss" module>
  @import './WindowСontrolButtons.sass';
</style>
